var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"button","value":_vm.schema.buttonText,"disabled":_vm.disabled},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }